import type { Referentiel } from './types.js';

/**
 * Données versionnées de l'écran D04c : libellés des scénarios, hypothèses cochables, niveaux de fiabilité,
 * grille du coût pour la famille et libellés de l'historique. Aucun seuil ni barème n'est écrit dans les composants.
 * La grille est fictive et provisoire tant que la spécialiste ne l'a pas confirmée (voir RFC-L62-001).
 */
export const REFERENTIEL: Referentiel = {
  version: '2026-10',
  scenarios: [
    { code: 'vendre', libelle: 'vendre le bien' },
    { code: 'partager', libelle: 'partager entre héritiers' },
    { code: 'sci', libelle: 'société civile immobilière' },
    { code: 'constructible', libelle: 'terrain constructible' },
  ],
  hypotheses: [
    { code: 'projet_constructif', libelle: 'Projet constructif des héritiers', scenario: 'constructible' },
    { code: 'plu_constructible', libelle: 'Le PLU rend le terrain constructible', scenario: 'constructible' },
  ],
  fiabilite: [
    { jusqua: 40, code: 'faible', libelle: 'faible' },
    { jusqua: 70, code: 'moyenne', libelle: 'moyenne' },
    { jusqua: 101, code: 'bonne', libelle: 'bonne' },
  ],
  grilleCoutFamille: {
    statut: 'Grille provisoire, à confirmer par la spécialiste',
    tranches: [
      { jusquaCentimes: 10_000_000, coutCentimes: 150_000 },
      { jusquaCentimes: 25_000_000, coutCentimes: 300_000 },
      { jusquaCentimes: null, coutCentimes: 450_000 },
    ],
  },
  historique: {
    valeur_modifiee: 'Valeur modifiée',
    fiabilite: 'Fiabilité modifiée',
    titre: 'Titre trouvé ou non : changement',
    solution_incomplete: 'Solution incomplète : changement',
    conjoint_recherche: 'Conjoint recherché : changement',
  },
};
